/**
 * useScrollPosition — tracks whether the window has been
 * scrolled past a threshold. Used by the sticky header to
 * transition between transparent and solid states.
 */

import { useEffect, useState } from 'react';

export function useScrollPosition(threshold = 8): boolean {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handler = () => {
      setIsScrolled(window.scrollY > threshold);
    };

    handler();
    window.addEventListener('scroll', handler, { passive: true });

    return () => window.removeEventListener('scroll', handler);
  }, [threshold]);

  return isScrolled;
}
